import whiteInstagramIcon from "../../assets/images/white-instagram-icon.png";
import whiteYoutubeIcon from "../../assets/images/white-youtube-icon.png";
import whiteWhatsappIcon from "../../assets/images/white-whatsapp-icon.png";
import style from "./socialmedia.module.css";
import supportLogo from "../../assets/svg/headset-dark-mode.svg"
export function SocialBar(props) {
  const { instagramUrl, youtubeUrl, whatsappUrl } = props;

  return (
    <div
      id={style.socialmedia_bar_contact}
      aria-label="Contact us on social media"
      className="d-flex justify-content-evenly align-items-center"
    >
      <a
        href={instagramUrl}
        target="_blank"
        rel="noopener"
        aria-label="Instagram"
      >
        <img
          className={style.socialmedia_icons}
          src={whiteInstagramIcon}
          alt="Instagram"
        />
      </a>
      <a href={youtubeUrl} target="_blank" rel="noopener" aria-label="Youtube">
        <img
          className={style.socialmedia_icons}
          src={whiteYoutubeIcon}
          alt="Youtube"
        />
      </a>
      <div className={style.socialmedia_white_strip}></div>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener"
        aria-label="Suporte Logo"
        className={`d-flex align-items-center gap-2 ${style.socialmedia_field_button_support_sociamedia} px-2`}
      >
        
        <img
          className={style.socialmedia_icons}
          src={supportLogo}
          alt="Suporte Logo"
        />
        <p className="text-light m-0 fs-4 fw-bold">
        Suporte
        </p>
      </a>
    </div>
  );
}
